module.exports = __webpack_public_path__ + "static/img/1-2.b104453.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/1-2.png
// module id = 8Q7Y
// module chunks = 0